import styled from 'styled-components';

export const TabsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.125rem;
`;
